import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Icon } from "antd";
import {
    columnBuilder,
    rowBuilder
} from "./utilities/table-utils";
import VisibilityViewTemplate from "./visibility-view-template";
import { OrderedMap, List } from "immutable";
import CompanyService from "./services/company-los-services";
class VisibilityView extends React.PureComponent {
    state = {
        companyId: this.props.match && this.props.match.params && this.props.match.params.companyId,
        rows: new List([]),
        columns: new OrderedMap({}),
        filters: new OrderedMap({}),
        filterValues: {},
        tableLoading: false,
        dataLoading: false,
        loading: true,
        childColumns: new OrderedMap({}),
        totalEntries: 0,
        dateFilters: []
    };

    componentDidMount() {
        CompanyService.getDateFilters(this.state.companyId).then(_ => {
            this.setState({
                dateFilters: _.data
            });
        });
        this.fetchVisibility();
    }
    filterTemplate = null;
    
    fetchVisibility = () => {
        CompanyService.getCompanyVisibilityColumns(this.state.companyId).then(_ => {
            const {
                data: { table_column, child_table_column }
            } = _;
            table_column.push({
                display: "MoM",
                data_key: "expand",
                sequence: 8,
                data_type: 0,
                is_visible: true,
                width: 50
            });
            let childColumn = child_table_column.map(_ => {
                let row = _;
                row.width = 80;
                return row;
            });
            this.setState(
                {
                    columns: columnBuilder(
                        table_column,
                        true
                    ),
                    childColumns: columnBuilder(
                        childColumn,
                        true
                    ),
                    tableLoading: false
                }
            );
        });
    }

    fetchVisibilityData = (filter_values, data) => {
        const { companyId } = this.state;
        if (
            companyId
        ) {
            this.setState({
                dataLoading: true
            });
            return CompanyService.getVisibilityData(companyId, filter_values, data).then(
                ({ data }) => {
                    if (data) {
                        this.setState({
                            rows: rowBuilder(data.results),
                            dataLoading: false,
                            totalEntries: data.count
                        });
                    }
                }
            );
        }
        this.setState({
            rows: rowBuilder([]),
            dataLoading: false
        });
    }
    onFilterApply = (filterValues, auto = false) => {
        this.setState(
            {
                filterValues
            },
            () => {
                if (auto) {
                    this.onFetchPress();
                }
            }
        );
    };

    getTable = () => {
        const {
            rows,
            columns,
            tableLoading,
            dataLoading
        } = this.state;
        if (tableLoading) {
            return "Loading";
        }
        return (
            <Row>
                <Col span={24}>
                    <VisibilityViewTemplate
                        rows={rows}
                        columns={columns}
                        loading={dataLoading}
                        childColumns={this.state.childColumns}
                        fetchVisibilityData={this.fetchVisibilityData}
                        companyId={this.state.companyId}
                        totalEntries={this.state.totalEntries}
                        history={this.props.history}
                        dateFilters={this.state.dateFilters}
                    />
                </Col>
            </Row>
        );
    }

    render() {
        return (
            <Row>
                <Row 
                    style={{
                        background: "#fff",
                        borderBottom: "1px solid #e8e8e8"
                    }}
                    span={24} 
                    className={"p-10 d-flex align-items-center"}
                >
                    <Icon onClick={() => this.props.history.goBack()} style={{fontSize: "20px"}} type={"arrow-left"} />
                    <h1 style={{
                        fontSize: "24px",
                        margin: 0,
                        marginLeft: "16px"
                    }}>{this.props.match && this.props.match.params && this.props.match.params.companyName}</h1>
                </Row>
                <Col span={24} className={"mt-20 pr-5 pl-5"}>
                    {this.state.companyId && this.getTable()}
                </Col>
            </Row>
        );
    }
}

VisibilityView.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object
};

export default VisibilityView;